import React from 'react';
import { Link } from 'react-router-dom';
import './BrandCard.css';

const BrandCard = ({ brandName, logoUrl }) => {
    return (
        <Link
            to={`/products?brand=${encodeURIComponent(brandName)}`}
            className="brand-card"
        >
            {logoUrl ? (
                <img
                    src={logoUrl}
                    alt={`${brandName} logo`}
                    className="brand-card-logo"
                />
            ) : (
                <h3 className="brand-card-title">{brandName}</h3>
            )}
        </Link>
    );
};

export default BrandCard;